import { render, staticRenderFns } from "./tagGroup.vue?vue&type=template&id=56c84540&scoped=true"
import script from "./tagGroup.vue?vue&type=script&lang=js"
export * from "./tagGroup.vue?vue&type=script&lang=js"
import style0 from "./tagGroup.vue?vue&type=style&index=0&id=56c84540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c84540",
  null
  
)

export default component.exports